// Rwanda Administrative Divisions - All 30 Districts and their Sectors
// Source: Rwanda National Institute of Statistics

export const RWANDA_SECTORS = {
  // Kigali City
  Gasabo: [
    'Bumbogo', 'Gatsata', 'Jali', 'Gikomero', 'Gisozi', 'Jabana',
    'Kacyiru', 'Kimihurura', 'Kimironko', 'Kinyinya', 'Ndera',
    'Nduba', 'Remera', 'Rusororo', 'Rutunga'
  ],
  Kicukiro: [
    'Gahanga', 'Gatenga', 'Gikondo', 'Kagarama', 'Kanombe',
    'Kicukiro', 'Kigarama', 'Masaka', 'Niboye', 'Nyarugunga'
  ],
  Nyarugenge: [
    'Gitega', 'Kanyinya', 'Kigali', 'Kimisagara', 'Mageragere',
    'Muhima', 'Nyakabanda', 'Nyamirambo', 'Nyarugenge', 'Rwezamenyo'
  ],

  // Southern Province
  Gisagara: [
    'Gikonko', 'Gishubi', 'Kansi', 'Kibilizi', 'Kigembe',
    'Mamba', 'Muganza', 'Mugombwa', 'Mukindo', 'Musha',
    'Ndora', 'Nyanza', 'Save'
  ],
  Huye: [
    'Gishamvu', 'Huye', 'Karama', 'Kigoma', 'Kinazi',
    'Maraba', 'Mbazi', 'Mukura', 'Ngoma', 'Ruhashya',
    'Rusatira', 'Rwaniro', 'Simbi', 'Tumba'
  ],
  Kamonyi: [
    'Gacurabwenge', 'Karama', 'Kayenzi', 'Kayumbu', 'Mugina',
    'Musambira', 'Ngamba', 'Nyamiyaga', 'Nyarubaka', 'Rukoma',
    'Rugarika', 'Runda'
  ],
  Muhanga: [
    'Cyeza', 'Kabacuzi', 'Kibangu', 'Kiyumba', 'Muhanga',
    'Mushishiro', 'Nyabinoni', 'Nyamabuye', 'Nyarusange', 'Rongi',
    'Rugendabari', 'Shyogwe'
  ],
  Nyamagabe: [
    'Buruhukiro', 'Cyanika', 'Gasaka', 'Gatare', 'Kaduha',
    'Kamegeri', 'Kibirizi', 'Kibumbwe', 'Kitabi', 'Mbazi',
    'Mugano', 'Musange', 'Musebeya', 'Mushubi', 'Nkomane',
    'Tare', 'Uwinkingi'
  ],
  Nyanza: [
    'Busasamana', 'Busoro', 'Cyabakamyi', 'Kibirizi', 'Kigoma',
    'Mukingo', 'Muyira', 'Ntyazo', 'Nyagisozi', 'Rwabicuma'
  ],
  Nyaruguru: [
    'Busanze', 'Cyahinda', 'Kibeho', 'Kivu', 'Mata',
    'Muganza', 'Munini', 'Ngera', 'Ngoma', 'Nyabimata',
    'Nyagisozi', 'Ruheru', 'Ruramba', 'Rusenge'
  ],
  Ruhango: [
    'Bweramana', 'Byimana', 'Kabagari', 'Kinazi', 'Kinihira',
    'Mbuye', 'Mwendo', 'Ntongwe', 'Ruhango'
  ],

  // Western Province
  Karongi: [
    'Bwishyura', 'Gashari', 'Gishyita', 'Gisovu', 'Gitesi',
    'Mubuga', 'Murambi', 'Murundi', 'Mutuntu', 'Rubengera',
    'Rugabano', 'Ruganda', 'Rwankuba'
  ],
  Ngororero: [
    'Bwira', 'Gatumba', 'Hindiro', 'Kabaya', 'Kageyo',
    'Kavumu', 'Matyazo', 'Muhanda', 'Muhororo', 'Ndaro',
    'Ngororero', 'Nyange', 'Sovu'
  ],
  Nyabihu: [
    'Bigogwe', 'Jenda', 'Jomba', 'Kabatwa', 'Karago',
    'Kintobo', 'Mukamira', 'Muringa', 'Rambura', 'Rugera',
    'Rurembo', 'Shyira'
  ],
  Nyamasheke: [
    'Bushekeri', 'Bushenge', 'Cyato', 'Gihombo', 'Kagano',
    'Kanjongo', 'Karambi', 'Karengera', 'Kirimbi', 'Macuba',
    'Mahembe', 'Nyabitekeri', 'Rangiro', 'Ruharambuga', 'Shangi'
  ],
  Rubavu: [
    'Bugeshi', 'Busasamana', 'Cyanzarwe', 'Gisenyi', 'Kanama',
    'Kanzenze', 'Mudende', 'Nyakiliba', 'Nyamyumba', 'Nyundo',
    'Rubavu', 'Rugerero'
  ],
  Rusizi: [
    'Bugarama', 'Butare', 'Bweyeye', 'Gashonga', 'Giheke',
    'Gihundwe', 'Gitambi', 'Kamembe', 'Muganza', 'Mururu',
    'Nkanka', 'Nkombo', 'Nkungu', 'Nyakabuye', 'Nyakarenzo',
    'Nzahaha', 'Rwimbogo'
  ],
  Rutsiro: [
    'Boneza', 'Gihango', 'Kigeyo', 'Kivumu', 'Manihira',
    'Mukura', 'Murunda', 'Musasa', 'Nyabirasi', 'Ruhango',
    'Rusebeya'
  ],

  // Northern Province
  Burera: [
    'Bungwe', 'Butaro', 'Cyanika', 'Cyeru', 'Gahunga',
    'Gatebe', 'Gitovu', 'Kagogo', 'Kinoni', 'Kinyababa',
    'Kivuye', 'Nemba', 'Rugarama', 'Rugendabari', 'Ruhunde',
    'Rusarabuye', 'Rwerere'
  ],
  Gicumbi: [
    'Bukure', 'Bwisige', 'Byumba', 'Cyumba', 'Giti',
    'Kaniga', 'Manyagiro', 'Miyove', 'Mukarange', 'Muko',
    'Mutete', 'Nyamiyaga', 'Nyankenke', 'Rubaya', 'Rukomo',
    'Rushaki', 'Rutare', 'Ruvune', 'Rwamiko', 'Shangasha'
  ],
  Musanze: [
    'Busogo', 'Cyuve', 'Gacaca', 'Gashaki', 'Gataraga',
    'Kimonyi', 'Kinigi', 'Muhoza', 'Muko', 'Musanze',
    'Nkotsi', 'Nyange', 'Remera', 'Rwaza', 'Shingiro'
  ],
  Rulindo: [
    'Base', 'Burega', 'Bushoki', 'Buyoga', 'Cyinzuzi',
    'Cyungo', 'Kinihira', 'Kisaro', 'Masoro', 'Mbogo',
    'Murambi', 'Ngoma', 'Ntarabana', 'Rukozo', 'Rusiga',
    'Shyorongi', 'Tumba'
  ],

  // Eastern Province
  Bugesera: [
    'Gashora', 'Juru', 'Kamabuye', 'Mareba', 'Mayange',
    'Musenyi', 'Mwogo', 'Ngeruka', 'Ntarama', 'Nyamata',
    'Nyarugenge', 'Rilima', 'Ruhuha', 'Rweru', 'Shyara'
  ],
  Gatsibo: [
    'Gasange', 'Gatsibo', 'Gitoki', 'Kabarore', 'Kageyo',
    'Kiramuruzi', 'Kiziguro', 'Muhura', 'Murambi', 'Ngarama',
    'Nyagihanga', 'Remera', 'Rugarama', 'Rwimbogo'
  ],
  Kayonza: [
    'Gahini', 'Kabare', 'Kabarondo', 'Mukarange', 'Murama',
    'Murundi', 'Mwiri', 'Ndego', 'Nyamirama', 'Rukara',
    'Ruramira', 'Rwinkwavu'
  ],
  Kirehe: [
    'Gahara', 'Gatore', 'Kigarama', 'Kigina', 'Kirehe',
    'Mahama', 'Mpanga', 'Musaza', 'Mushikiri', 'Nasho',
    'Nyamugari', 'Nyarubuye'
  ],
  Ngoma: [
    'Gashanda', 'Jarama', 'Karembo', 'Kazo', 'Kibungo',
    'Mugesera', 'Murama', 'Mutenderi', 'Remera', 'Rukira',
    'Rukumberi', 'Rurenge', 'Sake', 'Zaza'
  ],
  Nyagatare: [
    'Gatunda', 'Karama', 'Karangazi', 'Katabagemu', 'Kiyombe',
    'Matimba', 'Mimuri', 'Mukama', 'Musheri', 'Nyagatare',
    'Rukomo', 'Rwempasha', 'Rwimiyaga', 'Tabagwe'
  ],
  Rwamagana: [
    'Fumbwe', 'Gahengeri', 'Gishari', 'Karenge', 'Kigabiro',
    'Muhazi', 'Munyaga', 'Munyiginya', 'Musha', 'Muyumbu',
    'Mwulire', 'Nyakariro', 'Nzige', 'Rubona'
  ]
};

// Function to get all sectors as a flat array
export const getAllSectors = () => {
  const allSectors = [];
  Object.keys(RWANDA_SECTORS).forEach(district => {
    RWANDA_SECTORS[district].forEach(sector => {
      allSectors.push({ district, sector });
    });
  });
  return allSectors;
};

// Function to search sectors
export const searchSectors = (query) => {
  const results = {};
  const lowerQuery = query.toLowerCase();
  
  Object.keys(RWANDA_SECTORS).forEach(district => {
    const matchingSectors = RWANDA_SECTORS[district].filter(sector =>
      sector.toLowerCase().includes(lowerQuery) ||
      district.toLowerCase().includes(lowerQuery)
    );
    if (matchingSectors.length > 0) {
      results[district] = matchingSectors;
    }
  });
  
  return results;
};
